import React, { Component } from "react";
import "./rotatableImage.css";
import { withTranslation } from "react-i18next";

class RotatableImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgLoaded: false,
      rotate: 0,
      dimensions: {
        height: 0,
        width: 0
      },
      componentDimensions: {
        height: 0,
        width: 0
      }
    };

    this.rotator = this.rotator.bind(this);
    this.onImgLoad = this.onImgLoad.bind(this);
    this.getImageCss = this.getImageCss.bind(this);
    this.rotateEventCallback = this.rotateEventCallback.bind(this);
  }
  componentDidMount() {
    document.addEventListener("keydown", this.rotateEventCallback);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.rotateEventCallback);
  }

  rotateEventCallback(e) {
    if (this.props.side == "left") {
      switch (e.key) {
        case "q":
          this.rotator(-1);
          break;
        case "w":
          this.rotator(1);
          break;
        default:
          break;
      }
    }
    if (this.props.side == "right") {
      switch (e.key) {
        case "o":
          this.rotator(-1);
          break;
        case "p":
          this.rotator(1);
          break;
        default:
          break;
      }
    }
  }

  rotator(modifier) {
    const newValue = (this.state.rotate + modifier + 4) % 4;
    this.setState({
      rotate: newValue
    });
  }
  onImgLoad({ target: img }) {
    this.setState({
      dimensions: { height: img.height, width: img.width },
      componentDimensions: {
        width: this.compWrapper.clientWidth
      },
      imgLoaded: true
    });
  }
  getImageCss() {
    let css = {};
    if (this.state.imgLoaded) {
      switch (this.state.rotate) {
        case 0:
          css.transform = "none";
          css.transformOrigin = "center center";
          css.maxWidth = this.state.componentDimensions.width;
          break;
        case 1:
          css.transform = "rotate(90deg)";
          css.transformOrigin = "center center";
          css.maxHeight = this.state.componentDimensions.width;
          break;
        case 2:
          css.transform = "rotate(180deg)";
          css.transformOrigin = "center center";
          css.maxWidth = this.state.componentDimensions.width;
          break;
        case 3:
          css.transform = "rotate(270deg)";
          css.transformOrigin = "center center";
          css.maxHeight = this.state.componentDimensions.width;
          break;
        default:
          break;
      }
    }
    return css;
  }
  getImageWrapperCss() {
    /**
     * ratio calculate et
     * görselin boyutlarını hesapla dön
     */

    let css = {};
    if (this.state.imgLoaded) {
      const imgRatio =
        this.state.dimensions.height / this.state.dimensions.width;
      const isVertical = imgRatio >= 1;
      const isHorizontal = imgRatio < 1;

      if (isHorizontal) {
        //yatay gorsellerde componentin genisligi, gorselin yeni genisligi olur
        const displayedImageWidth = this.state.componentDimensions.width;
        //bu yuzden gorselin dikey ratiosunu hesaplayip
        const verticalImgRatio =
          this.state.dimensions.width / this.state.dimensions.height;
        //yeni gorsel yuksekligini buluyoruz
        const imgHeight = displayedImageWidth * verticalImgRatio;

        switch (this.state.rotate) {
          case 1:
          case 3:
            css.height = imgHeight;
            break;
          default:
            break;
        }
      } else if (isVertical) {
        //dikey gorsellerde componentin genisligi, gorselin yeni genisligi olur
        const displayedImageWidth = this.state.componentDimensions.width;
        //bu yuzden gorselin dikey ratiosunu hesaplayip
        const verticalImgRatio =
          this.state.dimensions.width / this.state.dimensions.height;
        //yeni gorsel yuksekligini buluyoruz
        const imgWidth = displayedImageWidth * verticalImgRatio;
        switch (this.state.rotate) {
          case 1:
          case 3:
            css.height = imgWidth;
            break;
          default:
            break;
        }
      }
    }
    return css;
  }
  render() {
    const { t } = this.props;
    return (
      <div
        className="rotatable-wrapper"
        ref={(compWrapper) => (this.compWrapper = compWrapper)}
      >
        <div
          className="rotatable-image-wrapper"
          style={this.getImageWrapperCss()}
        >
          <img
            src={this.props.src}
            onLoad={this.onImgLoad}
            style={this.getImageCss()}
          />
        </div>
        <div className="flex-line rotate-controls-wrapper">
          <div className="rotate-button" onClick={(e) => this.rotator(-1)}>
            <i className="fas fa-undo" />
            <span>{t("rotateLeft")}</span>
          </div>
          <div className="rotate-button" onClick={(e) => this.rotator(+1)}>
            <i className="fas fa-undo fa-flip-horizontal" />
            <span>{t("rotateRight")}</span>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("kunduz")(RotatableImage);
